import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_DOW_DEMO_DNA1_4 = {
  title: `A proactive alert locates the source of a \nfailure and provides a detailed reason for \nthe error. With this information, Lyn is \nable to <span style="color: #BEE3FF;">identify the root cause and \nresolve the ticket in minutes</span>.`,
  subtitle: "Data Operations Workbench demo",
  label: [
    { iconPath: "start.png", text: "Monitoring" },
    { iconPath: "start.png", text: "Failure Alert" },
  ],
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(109),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(107),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA1/DNA1_intro_04.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "DNA1/DNA1_DOW_DEMO_04_Computer.png",
          imageStyle: {
            position: "absolute",
            right: "112px",
            bottom: "225.84px",
          },
          effect: "animate-opacity",
        },
        {
          image: "DNA1/DNA1_DOW_DEMO_04_PopUp_1.png",
          imageStyle: { position: "absolute", right: "197px", bottom: "558px" },
          effect: "animate-opacity",
        },
        {
          image: "DNA1/DNA1_DOW_DEMO_04_PopUp_2.png",
          imageStyle: { position: "absolute", right: "139px", bottom: "197px" },
          effect: "animate-opacity",
        },
      ]}
      pageNumber={108}
    />
  ),
};
